import { useDataProvider } from 'react-admin';
import { useQuery } from '@tanstack/react-query';

export const useProductBrands = () => {
    const dataProvider = useDataProvider();

    return useQuery({
        queryKey: ['product-brands-mock'],
        queryFn: () =>
            dataProvider.getList('product-brands-mock', {
                pagination: { page: 1, perPage: 100 },
                sort: { field: 'brand', order: 'ASC' },
                filter: {},
            }),
        select: response => response.data?.map(b => b.brand) || [],
    });
};
